import React from 'react'
import './CreateSituationForm.scss'

import { Grid, Typography, InputLabel } from '@material-ui/core'
import { FieldArray } from 'formik'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'

import { InputField, SelectField } from '../../FormFields'
import { selector_area_types } from '../../../../config/constant'

interface AreasArrayHelpers {
    push: any
    remove: any
    form: any
}

interface PolygonPointsProps {
    areaIndex: number
    areasArrayHelpers: AreasArrayHelpers
}

const PolygonPoints = ({ areaIndex, areasArrayHelpers }: PolygonPointsProps) => {
    const { push, remove, form } = areasArrayHelpers
    const { values } = form
    const { areas } = values

    return (
        <>
            <Typography variant="subtitle1" gutterBottom>
                New area polygon
            </Typography>
            {areas[areaIndex].polygon.map((_point: any, index: number) => (
                <div key={index}>
                    <br />
                    <Grid container spacing={3}>
                        <Grid item xs={6} sm={6}>
                            <InputLabel shrink>
                                Latitude <span className="RequiredRed">*</span>
                            </InputLabel>
                            <InputField name={`areas[${areaIndex}].polygon[${index}].lat`} fullWidth />
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <InputLabel shrink>
                                Longitude <span className="RequiredRed">*</span>
                            </InputLabel>
                            <InputField name={`areas[${areaIndex}].polygon[${index}].lon`} fullWidth />
                        </Grid>
                    </Grid>
                    {index > 0 && (
                        <button
                            className="btn outline red RemoveButton"
                            onClick={() => remove(index)}
                            data-test-id="usecase-create_situation_form_remove_coordinate"
                        >
                            Remove Coordinate
                        </button>
                    )}
                </div>
            ))}
            <br />
            <span className="AddButton" onClick={() => push({ lat: '', lon: '' })}>
                <AddCircleOutlineIcon />
                Add Coordinate
            </span>
            <br />
            <br />
        </>
    )
}

interface CreateSituationFormProps {
    formField: any
}

function CreateSituationForm(_props: CreateSituationFormProps) {
    const defaultValues = {
        name: '',
        polygon: [{ lat: '', lon: '' }],
    }

    return (
        <div className="CreateSituationForm" data-test-id="usecase-create_situation_form">
            <React.Fragment>
                <Typography variant="h6" gutterBottom>
                    Main Map
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <InputLabel shrink>
                            Map Name <span className="RequiredRed">*</span>
                        </InputLabel>
                        <InputField type="text" name={'main_area_name'} fullWidth />
                    </Grid>
                </Grid>
                <br />
                <Typography variant="subtitle1" gutterBottom>
                    Initial Position
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={6} sm={6}>
                        <InputLabel shrink>
                            Latitude <span className="RequiredRed">*</span>
                        </InputLabel>
                        <InputField name={'main_area_lat'} fullWidth />
                    </Grid>
                    <Grid item xs={6} sm={6}>
                        <InputLabel shrink>
                            Longitude <span className="RequiredRed">*</span>
                        </InputLabel>
                        <InputField name={'main_area_lon'} fullWidth />
                    </Grid>
                </Grid>
                <br />
                <br />
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <div>
                            <FieldArray name="areas">
                                {(fieldArrayProps) => {
                                    const { push, remove, form } = fieldArrayProps
                                    const { values } = form
                                    const { areas } = values
                                    return (
                                        <div>
                                            {areas.map((_area: any, index: number) => (
                                                <div key={index}>
                                                    <Typography variant="h6" gutterBottom>
                                                        New Area {index + 1}
                                                    </Typography>
                                                    <InputLabel shrink>
                                                        Area Name <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <InputField type="text" name={`areas[${index}].name`} fullWidth />
                                                    <br />
                                                    <br />
                                                    <InputLabel shrink>
                                                        Type <span className="RequiredRed">*</span>
                                                    </InputLabel>
                                                    <SelectField name={`areas[${index}].type`} data={selector_area_types} fullWidth />
                                                    <br />
                                                    <br />
                                                    <FieldArray name={`areas[${index}].polygon`}>
                                                        {(fieldArrayAreaProps) => (
                                                            <>
                                                                <PolygonPoints areaIndex={index} areasArrayHelpers={fieldArrayAreaProps} />
                                                            </>
                                                        )}
                                                    </FieldArray>
                                                    {index > 0 && (
                                                        <>
                                                            <button
                                                                className="btn outline red RemoveButton"
                                                                onClick={() => remove(index)}
                                                                data-test-id="usecase-create_situation_form_remove_area"
                                                            >
                                                                Remove Area {areas[index].name}
                                                            </button>
                                                            <br />
                                                        </>
                                                    )}
                                                </div>
                                            ))}
                                            <span className="AddButton" onClick={() => push(defaultValues)}>
                                                <AddCircleOutlineIcon />
                                                Add An Area
                                            </span>
                                        </div>
                                    )
                                }}
                            </FieldArray>
                        </div>
                    </Grid>
                </Grid>
            </React.Fragment>
        </div>
    )
}

export default CreateSituationForm
